import React, { useState } from 'react';
import fa from 'locales/fa.json';
import { Modal, Skeleton, Spin, Table } from 'antd';
import AntButton from 'components/Common/AntButton';
import request from 'services/request';
import { MyCreateQuestionUrl } from 'services/routes';
import CreateQuestionModal from 'components/Common/CreateQuestionModal';

const MyCreateQuestion: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(0);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const selectedItem = list?.[editIndex - 1];

  const handleLoadMore = async (): Promise<void> => {
    setPageLoading(true);
    const res: any = await request.get(MyCreateQuestionUrl(page + 1)); // eslint-disable-line
    setPageLoading(false);
    setPage(page + 1);
    res.ok && setList([...list, ...res.data.data]);
  };

  const handleClick = async (): Promise<boolean> => {
    setLoading(true);
    const res: any = await request.get(MyCreateQuestionUrl(1)); // eslint-disable-line
    setLoading(false);
    if (res.ok) {
      setShowModal(true);
      setList(res.data.data);
      setPage(1);
      return true;
    }
    return null;
  };

  const updateList = (options, answer, question, hint): void => {
    const newList = list.map((item) =>
      item.id === selectedItem.id ? { ...item, options, answer, question, hint } : item,
    );
    setList(newList);
  };

  const dataSource = list.map((item, index) => ({
    title: item.exam_title,
    moreDetails: item.more,
    edit: (
      <AntButton
        onClick={(): void => setEditIndex(index + 1)}
        disabled={item.published === 1}
      >
        {fa.global.edit}
      </AntButton>
    ),
  }));

  const columns = ['title', 'moreDetails', 'edit'].map((item) => ({
    title: fa.global[item],
    dataIndex: item,
  }));

  return (
    <div className="mb-3">
      <div onClick={handleClick} className="cursor-pointer hover:text-blue-0">
        {fa.account.myCreatedQuestions} <Spin spinning={loading} />
      </div>
      <Modal
        title={null}
        footer={null}
        width={1400}
        destroyOnClose
        visible={showModal}
        onCancel={(): void => (setShowModal(false), setList([]), setPage(1))}
      >
        <div className="flex flex-col w-full self-start">
          <div className="self-center font-bold text-[18px] mb-[24px]">
            {fa.account.questionList}
          </div>

          <div className="flex flex-wrap gap-[16px] justify-center">
            {!list.length && <div>{fa.global.noData}</div>}
            <div className="w-full">
              <Table dataSource={dataSource} columns={columns} pagination={false} />
            </div>
          </div>

          {list.length === 20 * page && (
            <div className="w-full px-[30px] text-center my-[30px]">
              {pageLoading ? (
                <Skeleton active />
              ) : (
                <AntButton width="200px" onClick={handleLoadMore}>
                  {fa.course.loadMore}
                </AntButton>
              )}
            </div>
          )}
        </div>
      </Modal>

      <CreateQuestionModal
        id={selectedItem?.id}
        isOpen={!!editIndex}
        setOpen={setEditIndex}
        updateList={updateList}
        defaultValues={{
          question: selectedItem?.question,
          answer: selectedItem?.answer,
          hint: selectedItem?.hint,
          option1: selectedItem?.options[0].option,
          option2: selectedItem?.options[1].option,
          option3: selectedItem?.options[2].option,
          option4: selectedItem?.options[3].option,
        }}
      />
    </div>
  );
};

export default MyCreateQuestion;
